import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'logs',
    path: 'logs',
    component: () => import('../LogsIndex.vue'),
  },
];
